module.exports = __webpack_public_path__ + "assets/settings.e20ded87d53092d9bd155809d5926363.png";


//////////////////
// WEBPACK FOOTER
// ./img/settings.png
// module id = 943
// module chunks = 0